import { createUseStyles } from 'react-jss';

const styles = createUseStyles(theme => ({
  tailViewMore: {
    color: '#007bff'
  }
}));

export default styles;
